export var TABLE_STRUCTURE_ELEMENTS = {
  TABLE_POSITION: 'tablePosition',
  TABLE_SHAPE: 'tableShape',
  TABLE_KEY: 'tableKey',
  TABLE_STYLE: 'tableStyle'
};